// src/utils/data.js
export const treesData = [
    { 
        id: 1, 
        name: "Almond Tree", 
        scientificName: "Prunus dulcis",
        category: "fruit", 
        price: 70000, 
        desc: "Prunus dulcis - Beautiful spring flowers", 
        icon: "🌸" 
    },
    { 
        id: 2, 
        name: "Apple Tree", 
        scientificName: "Malus domestica",
        category: "fruit", 
        price: 85000, 
        desc: "Malus domestica - Delicious apples", 
        icon: "🍎", 
        badge: "Popular" 
    },
    { 
        id: 3, 
        name: "Cedar Tree", 
        scientificName: "Cedrus",
        category: "native evergreen", 
        price: 130000, 
        desc: "Cedrus - Majestic evergreen", 
        icon: "🌲" 
    },
    { 
        id: 4, 
        name: "Apricot Tree", 
        scientificName: "Prunus armeniaca",
        category: "fruit fast-growing", 
        price: 75000, 
        desc: "Prunus armeniaca - Sweet apricots", 
        icon: "🍑" 
    },
    { 
        id: 5, 
        name: "Plane Tree", 
        scientificName: "Platanus orientalis",
        category: "native", 
        price: 100000, 
        desc: "Platanus orientalis - Great shade", 
        icon: "🌳", 
        badge: "Premium" 
    },
    { 
        id: 6, 
        name: "Walnut Tree", 
        scientificName: "Juglans regia",
        category: "fruit native", 
        price: 110000, 
        desc: "Juglans regia - Nutritious walnuts", 
        icon: "🌳", 
        badge: "Best Value" 
    }
];

export const plantingRegions = [  
    "Qoraqalpogʻiston Respublikasi",
  "Andijon viloyati",
  "Buxoro viloyati",
  "Fargʻona viloyati",
  "Jizzax viloyati",
  "Xorazm viloyati",
  "Namangan viloyati",
  "Navoiy viloyati",
  "Qashqadaryo viloyati",
  "Samarqand viloyati",
  "Sirdaryo viloyati",
  "Surxondaryo viloyati",
  "Toshkent viloyati",
  "Toshkent shahri",
];

export const paymentMethods = [
    { id: 'payme', name: 'Payme', icon: '💳' },
    { id: 'click', name: 'Click', icon: '📱' },
    { id: 'uzum', name: 'Uzum', icon: '🟣' }
];